import { DebugLogger } from 'lib/debugLogger';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { features } from 'reactApp/mail-features';
import { UnlimitedDocumentsTariffType } from 'reactApp/modules/unlimitedDocuments/unlimitedDocuments.const';

const DAY_S = 86400;

const platformCondition = !IS_MOBILE_BROWSER && !IS_WEBVIEW;

const unlimitedDocsFakedoorConfigRaw = features.getAsJSONWithDefaults('unlimited-docs-fakedoor-config', {
    enable: false,
    groupId: '',
    type: UnlimitedDocumentsTariffType.document,
    homePromo: {
        enable: false,
        showLimit: 3,
        closeLimit: 4,
        showInterval: 2 * DAY_S,
    },
    asidePromo: {
        enable: false,
        showLimit: 3,
        closeLimit: 4,
        showInterval: 2 * DAY_S,
    },
    leftBlockBanner: {
        enable: false,
        showLimit: 3,
        closeLimit: 4,
        showInterval: 2 * DAY_S,
    },
}) as {
    // общая включалка
    enable: boolean;

    groupId: string;

    // тип фейкдора (документы, презентации, таблицы)
    type: UnlimitedDocumentsTariffType;

    // основное промо при входе
    homePromo: {
        enable?: boolean;
        showLimit?: number;
        closeLimit?: number;
        showInterval?: number;
    };

    // баннер в левом нижнем углу
    asidePromo: {
        enable?: boolean;
        showLimit?: number;
        closeLimit?: number;
        showInterval?: number;
    };

    // баннер в левом сайдбаре под блоком квоты
    leftBlockBanner: {
        enable?: boolean;
        showLimit?: number;
        closeLimit?: number;
        showInterval?: number;
    };
};

export type UnlimitedDocumentsFakedoorConfigType = typeof unlimitedDocsFakedoorConfigRaw;

export const unlimitedDocsFakedoorConfig: UnlimitedDocumentsFakedoorConfigType = JSON.parse(JSON.stringify(unlimitedDocsFakedoorConfigRaw));

const enableFlag = !!(platformCondition && unlimitedDocsFakedoorConfigRaw.enable);
unlimitedDocsFakedoorConfig.homePromo.enable = !!(enableFlag && unlimitedDocsFakedoorConfig.homePromo.enable);
unlimitedDocsFakedoorConfig.leftBlockBanner.enable = !!(enableFlag && unlimitedDocsFakedoorConfig.leftBlockBanner.enable);
unlimitedDocsFakedoorConfig.asidePromo.enable = !!(enableFlag && unlimitedDocsFakedoorConfig.asidePromo.enable);

export const unlimitedDocumentsDebug: boolean = features.has('unlimited-documents-debug');

export const unlimitedDocumentsLogger = new DebugLogger({ DEBUG_SCOPE: 'UnlimitedDocuments', DEBUG: unlimitedDocumentsDebug });

const docTypeShortcut: { [k in UnlimitedDocumentsTariffType]: string } = {
    [UnlimitedDocumentsTariffType.document]: 'doc',
    [UnlimitedDocumentsTariffType.spreadsheet]: 'sh',
    [UnlimitedDocumentsTariffType.presentation]: 'pr',
};

if (platformCondition) {
    registerExperiment(
        'unldoc',
        unlimitedDocsFakedoorConfig.groupId,
        [
            AnalyticEventNames.UNLIMITED_DOCUMENTS_MODAL_SHOW,
            AnalyticEventNames.UNLIMITED_DOCUMENTS_MODAL_CLICK,
            AnalyticEventNames.UNLIMITED_DOCUMENTS_MODAL_CLOSE,

            AnalyticEventNames.UNLIMITED_DOCUMENTS_ASIDE_BANNER_SHOW,
            AnalyticEventNames.UNLIMITED_DOCUMENTS_ASIDE_BANNER_CLICK,
            AnalyticEventNames.UNLIMITED_DOCUMENTS_ASIDE_BANNER_CLOSE,

            AnalyticEventNames.UNLIMITED_DOCUMENTS_THANKS_MODAL_SHOW,
            AnalyticEventNames.UNLIMITED_DOCUMENTS_THANKS_MODAL_CLICK,
            AnalyticEventNames.UNLIMITED_DOCUMENTS_THANKS_MODAL_CLOSE,

            AnalyticEventNames.UNLIMITED_DOCUMENTS_SIDEBAR_BANNER_SHOW,
            AnalyticEventNames.UNLIMITED_DOCUMENTS_SIDEBAR_BANNER_CLICK,
        ],
        {
            sendXrayArgs: {
                UNLIMITED_DOCUMENTS_MODAL_SHOW: ({ doc_type, offer_source }) => ({
                    eventName: `fd-show-${docTypeShortcut[doc_type]}-${offer_source}`,
                }),
                UNLIMITED_DOCUMENTS_MODAL_CLICK: ({ doc_type, offer_source }) => ({
                    eventName: `fd-click-${docTypeShortcut[doc_type]}-${offer_source}`,
                }),
                UNLIMITED_DOCUMENTS_MODAL_CLOSE: ({ doc_type, offer_source }) => ({
                    eventName: `fd-close-${docTypeShortcut[doc_type]}-${offer_source}`,
                }),

                UNLIMITED_DOCUMENTS_ASIDE_BANNER_SHOW: ({ doc_type }) => ({ eventName: `aside-show-${docTypeShortcut[doc_type]}` }),
                UNLIMITED_DOCUMENTS_ASIDE_BANNER_CLICK: ({ doc_type }) => ({ eventName: `aside-click-${docTypeShortcut[doc_type]}` }),
                UNLIMITED_DOCUMENTS_ASIDE_BANNER_CLOSE: ({ doc_type }) => ({ eventName: `aside-close-${docTypeShortcut[doc_type]}` }),

                UNLIMITED_DOCUMENTS_THANKS_MODAL_SHOW: ({ offer_source }) => ({ eventName: `thanks-show-${offer_source}` }),
                UNLIMITED_DOCUMENTS_THANKS_MODAL_CLICK: ({ offer_source }) => ({ eventName: `thanks-click-${offer_source}` }),
                UNLIMITED_DOCUMENTS_THANKS_MODAL_CLOSE: ({ offer_source }) => ({ eventName: `thanks-close-${offer_source}` }),

                UNLIMITED_DOCUMENTS_SIDEBAR_BANNER_SHOW: ({ doc_type }) => ({ eventName: `banner-show-${docTypeShortcut[doc_type]}` }),
                UNLIMITED_DOCUMENTS_SIDEBAR_BANNER_CLICK: ({ doc_type }) => ({ eventName: `banner-click-${docTypeShortcut[doc_type]}` }),
            },
        }
    );
}
